
export default ({
  getToken: function () {
    return localStorage.getItem('token');
  },

  getEmail: function () {
    return localStorage.getItem('email');
  },

  getRoles: function () {
    return JSON.parse(localStorage.getItem('roles') || '{}');
  },

  setStorage: function (token, email, roles) {
    localStorage.setItem('token', token);
    localStorage.setItem('email', email);
    localStorage.setItem('roles', JSON.stringify(roles));
  },

  setRoles: function (roles) {
    localStorage.setItem('roles', JSON.stringify(roles));
  },

  clear: function () {
    localStorage.removeItem('token');
    localStorage.removeItem('email');
    localStorage.removeItem('roles');
  },
});



// WEBPACK FOOTER //
// ./src/providers/storage.js